import axios from '../shared/axios';
// import qs from 'querystring';

export function createRegister(data) {
    return axios.post(`/api/Register/CreateRegister`, data);
}
export function getRegisterList() {
    return axios.get('/api/Register/GetRegisterList');
  }
export function getRegister(registerid) {
    return axios.get(`/api/Register/GetRegister?registerid=${registerid}`);
}

export function createScheduledRegister(data) {
    return axios.post(`/api/Register/CreateScheduledRegister`, data);
}

export function getScheduledRegisters() {
    return axios.get(`/api/Register/GetScheduledRegisters`);
}

export function deleteScheduledRegister(scheduleId) {
    return axios.post(`/api/Register/DeleteScheduledRegister`, null, {
        params: { scheduleId: scheduleId }
    });
} 

export function downloadByToken(reportToken) {
    return axios.get(`/api/Register/DownloadRegisterSecure?reportToken=${reportToken}`, {
        responseType: 'blob'
    });
}
